import '../../../../static-source/helpers/gettext/shim';
import Vue from 'vue';
import Vuex from 'vuex';

import GettextMixin from '../../../../static-source/helpers/gettext/mixin';

import CellphoneRecovery from './components/cellphone_recovery';
import cellphoneRecoveryStore, {
    // eslint-disable-next-line no-unused-vars
    MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS,
    CELLPHONE_RECOVERY_STORE_NAMESPACE,
    MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS,
} from './store';

import inputMaxLengthDirective from '../../../../static-source/directives/inputMaxLength';
import inputSetFocusDirective from '../../../../static-source/directives/inputSetFocus';
import SmsVerificationCellphoneRecoveryForm from '../../../../static-source/components/sms_verification_cellphone_recovery_form/index.js';

Vue.use(Vuex);
Vue.directive('maxlength', inputMaxLengthDirective);
Vue.directive('focus', inputSetFocusDirective);

Vue.mixin(GettextMixin);

Vue.component('sms-verification-cellphone-recovery-form', SmsVerificationCellphoneRecoveryForm);

const store = new Vuex.Store({
    modules: {
        [CELLPHONE_RECOVERY_STORE_NAMESPACE]: cellphoneRecoveryStore,
        settings: {
            namespaced: true,
            state: {
                staticUrl: '/id/static/',
            },
        },
    },
});

const waitForBackendData = () => new Promise((resolve) => {
    if (window.cellphoneRecoveryData) {
        resolve(window.cellphoneRecoveryData);
    } else {
        setTimeout(() => waitForBackendData().then(resolve), 100);
    }
});

const initApp = async () => {
    try {
        const { cellphoneSettings, countryCallingCodesOptions } = await waitForBackendData();

        const settingsToUpdate = {
            MinLength: parseInt(cellphoneSettings.cellphoneMinLength, 10),
            MaxLength: parseInt(cellphoneSettings.cellphoneMaxLength, 10),
            riddlerFeature: cellphoneSettings.riddlerFeature || '',
            riddlerDefaultType: cellphoneSettings.riddlerDefaultType || '',
            urls: cellphoneSettings.urls || {},
            codeLifetime: cellphoneSettings.codeLifetime || '',
            smsMaxAttempts: cellphoneSettings.smsMaxAttempts || '',
            codeLength: cellphoneSettings.codeLength || '',
            countryCodeByIp: (cellphoneSettings.countryCodeByIp && cellphoneSettings.countryCodeByIp.CountryCode) || '',
        };

        store.commit(`${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`, settingsToUpdate);
        store.commit(`${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS}`, countryCallingCodesOptions);

        const App = new Vue({
            store,
            components: {
                CellphoneRecovery,
            },
        });

        window.App = App;
        window.App.store = store;

        App.$mount('.vv-app');
    } catch (error) {
        console.error('Error initializing app:', error);
    }
};

initApp();
